// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
// Config
import config from './config'

firebase.initializeApp(config)
